module.exports = __webpack_public_path__ + "img/ufo-art-02.fe9e36a4.webp";